<ng-container *ngIf="laborSchedule">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ laborSchedule.name || 'New Schedule' }}</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="true"
				[hideCancel]=""
				[hideDelete]=""
				[hideSave]=""
				(onCancelChange)="back()"
				(onDeleteChange)="delete()"
				(onSaveChange)="saveButtonAction()"
				[deleteDisabled]="deleteDisabled()"
				[saveDisabled]="saveDisabled()"
				[saveLabel]="saveLabel()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="card">
		<div class="p-grid">
			<div class="p-col-12">
				<span class="p-float-label mt-4">
					<input pInputText #scheduleNameInput name="scheduleNameInput" type="text" [(ngModel)]="laborSchedule.name" class="w-100" />
					<label for="scheduleNameInput">Schedule name</label>
				</span>
			</div>
		</div>
		<div class="d-flex">
			<span class="p-float-label mt-4">
				<p-calendar #startDateInput name="startDateInput" [(ngModel)]="startDatePrimeNgFormat" (ngModelChange)="dateChange($event)"></p-calendar>
				<label for="startDateInput">Schedule Starting Date</label>
			</span>
			<div class="ms-4">
				<span class="p-float-label mt-4">
					<p-multiSelect
						#accessibleEmployeeJobsList
						[options]="jobList"
						[(ngModel)]="accessibleEmployeeJobs"
						name="accessibleEmployeeJobsList"
						[maxSelectedLabels]="3"
						selectedItemsLabel="{0} jobs selected"
						appendTo="body"
						filter="true"
						(filterBy)="app.keys(jobList)"
						(onChange)="filterEmployeesForJobs($event)"
					>
						<ng-template let-option pTemplate="options">
							<div class="d-flex flex-column">
								<div class="display-14">
									{{ option.name }}
								</div>
								<small class="text-italics">
									{{ option.laborGroup.name }}
								</small>
							</div>
						</ng-template>
					</p-multiSelect>
					<label for="accessibleEmployeeJobsList">Filter employees by job</label>
				</span>
				<small *ngIf="accessibleEmployeeJobs.length !== 64" class="text-italics"> </small>
			</div>
		</div>
		<p-divider>Scheduled Employees</p-divider>
		<p-table
			#dt
			styleClass="p-datatable-gridlines p-datatable-striped labor-schedule"
			[value]="laborSchedule.employeeLaborScheduleEntries | arrayFilter: { display: true }"
			[loading]="!laborSchedule.employeeLaborScheduleEntries"
			[globalFilterFields]="app.keys(laborSchedule.employeeLaborScheduleEntries)"
			scrollHeight="700px"
			[scrollable]="true"
		>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="employeeId" class="column-name">
						<div class="d-flex w-100">
							<span class="display-12"> Employee </span>

							<p-sortIcon field="employeeId"></p-sortIcon>
							<div class="ms-auto">
								<p-columnFilter
									field="employeeId"
									matchMode="equals"
									display="menu"
									[showMatchModes]="false"
									[showOperator]="false"
									[showAddButton]="false"
									class="ml-auto"
								>
									<ng-template pTemplate="header">
										<div class="px-3 pt-3 pb-0">
											<span class="font-bold">Employee</span>
										</div>
									</ng-template>
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-multiSelect
											[ngModel]="value"
											[options]="employeeList"
											optionValue="id"
											placeholder="Any"
											(onChange)="filter($event.value)"
										>
											<ng-template let-option pTemplate="item">
												<div class="p-multiselect-representative-option">
													<span class="ml-1">{{ option.nickName }}</span>
												</div>
											</ng-template>
										</p-multiSelect>
									</ng-template>
								</p-columnFilter>
							</div>
						</div>
					</th>
					<ng-container *ngFor="let day of scheduleDays">
						<th class="column-event d-flex flex-column">
							<div class="display-12">
								{{ app.moment(laborSchedule.startDate).add(day, 'day').format('ddd') }}
							</div>
							<div class="display-14">
								{{ app.moment(laborSchedule.startDate).add(day, 'day').format('l') }}
							</div>
						</th>
					</ng-container>
					<th pSortableColumn="cost.regularCost" class="column-totals">
						<div class="d-flex w-100">
							Totals
							<p-sortIcon field="cost"></p-sortIcon>
							<div class="ms-auto">
								<p-columnFilter type="numeric" field="cost.regularCost" display="menu" class="ms-auto"></p-columnFilter>
							</div>
						</div>
					</th>
				</tr>
			</ng-template>
			<ng-template let-rec pTemplate="body">
				<tr class="schedule-row" [style.height]="rec.scheduleEntryDays * 40">
					<td class="column-name">
						<div class="column-name-content">
							<div class="d-flex w-100">
								<div
									class="display-12"
									[ngClass]="validateDropEmployeeFontColor(rec.employeeId) ? 'employee-shift-enabled' : 'employee-shift-disabled'"
								>
									{{ rec.employee.nickName }}
								</div>
								<div class="ms-auto">
									<fa-icon [icon]="['far', 'trash']" (click)="deleteRowPrompt(rec.employeeId)"></fa-icon>
								</div>
							</div>
							<div class="d-flex flex-wrap mt-2">
								<ng-container *ngFor="let job of rec.employee.jobs">
									<small class="text-italics mx-1">{{ job.name }}</small>
								</ng-container>
							</div>
						</div>
					</td>
					<ng-container *ngFor="let day of rec.scheduleEntryDays; index as i">
						<td
							(click)="rec.scheduleEntryDays[i].entries.length === 0 && selectEmployeeScheduleEvent(undefined, day, rec.employeeId)"
							pDroppable="laborShift"
							(onDrop)="shiftDestinationDragDrop($event, rec.employeeId, i)"
							style="width: 10%"
							class="column-event"
							[ngClass]="validateDropEmployeeFontColor(rec.employeeId) ? '' : 'employee-shift-drop-box-disabled'"
						>
							<div [ngClass]="day.entries.length > 0 ? 'employee-day-slot' : ''">
								<ng-container *ngFor="let entry of rec.scheduleEntryDays[i].entries">
									<div
										(click)="selectEmployeeScheduleEvent(entry, day, rec.employeeId)"
										class="employee-shift-card"
										pDraggable="laborShift"
										(onDragStart)="entryDragStart($event, entry)"
										(onDragEnd)="entryDragEnd($event, entry)"
									>
										<app-employee-schedule-time [scheduleEntry]="entry"></app-employee-schedule-time>
									</div>
								</ng-container>
							</div>
						</td>
					</ng-container>
					<td class="column-totals">
						<div class="column-totals-content display-14">
							<div>{{ app.moment.duration(rec.cost.totalMinutes, 'minutes').format('h [hrs], m [min]') }}</div>
							<div [ngClass]="rec.cost.dailyOvertimeCost || rec.cost.weeklyOvertimeCost ? 'd-flex text-danger' : 'd-flex'">
								{{ rec.cost.regularCost + rec.cost.dailyOvertimeCost + rec.cost.weeklyOvertimeCost | currency }}
								<fa-icon [icon]="['far', 'circle-info']" class="ms-auto" (click)="costSummary.toggle($event)"></fa-icon>
								<p-overlayPanel #costSummary>
									<div class="d-flex display-14 mb-1">
										Regular Time - {{ rec.cost.regularHours }} /hrs - {{ rec.cost.regularCost | currency }}
									</div>
									<div class="d-flex display-14 text-danger mb-1" *ngIf="rec.cost.dailyOvertimeHours">
										Daily Overtime - {{ rec.cost.dailyOvertimeHours }}/hrs - {{ rec.cost.dailyOvertimeCost | currency }}
									</div>
									<div class="d-flex display-14 text-danger mb-1" *ngIf="rec.cost.weeklyOvertimeHours">
										Weekly Overtime - {{ rec.cost.weeklyOvertimeHours }}/hrs - {{ rec.cost.weeklyOvertimeCost | currency }}
									</div>
								</p-overlayPanel>
							</div>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
		<div>
			<span class="p-float-label mt-4">
				<p-dropdown
					#newScheduleLineEmployeeInput
					[options]="employeeList"
					optionValue="id"
					name="newScheduleLineEmployeeInput"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					itemSize="30"
					filter="true"
					(filterBy)="app.keys(employeeList)"
					(onChange)="addNewRow($event)"
				>
					<ng-template pTemplate="selectedItem">
						<div class="display-14 text-italics">select employee to add to the schedule...</div>
					</ng-template>
					<ng-template pTemplate="item" let-option class="d-flex">
						<div class="display-14">{{ option.nickName }}</div>
						<ng-container *ngFor="let job of option.jobs">
							<small class="ms-2">{{ job.name }} ({{ job.payRate | currency }})</small>
						</ng-container>
					</ng-template>
				</p-dropdown>
				<label for="newScheduleLineEmployeeInput">Add Employee to Schedule</label>
			</span>
		</div>
	</div>

	<ng-container>
		<div class="mt-4 card">
			<p-divider>Shifts</p-divider>
			<div class="d-flex">
				<ng-container *ngFor="let shift of laborShiftList | arrayFilter: { visible: true }">
					<div
						pDraggable="laborShift"
						(onDragStart)="shiftDragStart($event, shift)"
						(onDragEnd)="shiftDragEnd($event, shift)"
						class="m-3 card d-flex flex-column"
						[style.background-color]="shift.color"
					>
						<div class="display-12">
							{{ shift.job.name }}
						</div>
						<div class="display-14">{{ shift.startTime }} - {{ shift.endTime }}</div>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</ng-container>

<app-employee-schedule-event
	*ngIf="selectedEntry"
	[(entry)]="selectedEntry"
	(deleteEntryChange)="entryDelete($event)"
	(saveEntryChange)="entrySave($event)"
	[scheduleStartDate]="laborSchedule.startDate"
></app-employee-schedule-event>
